const LowStockRenderer = ({ data }) => {
  const sub = [data.dosage, data.presentation].filter(Boolean).join(' · ');
  return (
    <>
      <p className="bell-card__name">{data.productName || '—'}</p>
      {sub && <p className="bell-card__sub">{sub}</p>}
      <p className="bell-card__detail">
        Qté : <strong>{Math.max(0, data.quantity)}</strong>
      </p>
    </>
  );
};

export default LowStockRenderer;
